import { Game, Round } from '@/redux/reducers/gameReducer'
import { LottoGameCardProps } from '@/ui-components/components/LottoGameCard'
import {
  convertToDateTime,
  DATE_TIME_FORMAT_HUMAN_SHORT,
} from '@/utils/date-time-utils'
import {
  getLottoNameAndCountryFromLottoGame,
  isEncryptLotto,
  isYeekeeType,
} from '@/utils/lotto-type-v2'
import { useTranslation } from 'react-i18next'
import { trans } from '@/i18n/utils'

const useLottoCardForHomePage = (): ((game: Game) => LottoGameCardProps) => {
  const { i18n, t } = useTranslation()

  return (game: Game): LottoGameCardProps => {
    const { name, country } = getLottoNameAndCountryFromLottoGame(
      game.type,
      game.flag,
    )
    const resp: LottoGameCardProps = {
      id: game.id.toString(),
      country: country,
      flagBannerName: name,
      title: trans(i18n, game.translations, 'name'),
      isOpen: game.is_enable === 'yes' ? true : false,
      gameLink: `/lotto/${game.code}/${game.id}`,
      activeRoundLink: `/lotto/${game.code}/${game.id}/${game.rounds?.[0]?.id}`,
      closedTime: '',
    }
    if (game.rounds.length === 1) {
      const round: Round = game.rounds?.[0]
      if (round.is_enable === 'yes') {
        resp.timeRemaining = new Date(round.close_at)
        const closeAtTxt = convertToDateTime(
          round.close_at,
          DATE_TIME_FORMAT_HUMAN_SHORT,
          i18n.language,
        )
        const detailText = t('lottoPage.status.close_at', {
          date: closeAtTxt,
        })
        resp.closedTime = detailText
      } else {
        resp.isOpen = false
      }
    }
    if (isYeekeeType(game.type) || isEncryptLotto(game.type)) {
      const openPrefix = t('lottoPage.status.open')
      const twentyFourHours = t('lottoPage.status.24hr')
      resp.closedTime = `${openPrefix} ${twentyFourHours}`

      // If it's a Yeekee or Encrypt Lotto, we set the active round link to the game link
      // User need to see all rounds in the game page first
      resp.activeRoundLink = resp.gameLink
    }

    if (game.rounds.length === 0) {
      resp.isOpen = false
    }

    return resp
  }
}

export default useLottoCardForHomePage
